interface PreviewInfoProps {
  hiddenRows: number;
}

export const PreviewInfo = ({ hiddenRows }: PreviewInfoProps) => {
  if (hiddenRows <= 0) {
    return null;
  }

  return (
    <div className="flex-shrink-0 pb-2 text-center text-xs text-gray-400">
      {`${hiddenRows} ${
        hiddenRows === 1 ? "row" : "rows"
      } hidden from preview. Run full batch to see all results.`}
    </div>
  );
};
